import api from 'api';

export const loadConceptsGrid = api('POST /api/gallery-concepts/grid');

export const loadConcept = api('GET /api/gallery-concepts/:id');
export const loadConceptDetails = api('GET /api/gallery-concepts/:id/details');
export const archiveConcept = api('POST /api/gallery-concepts/archive');
export const activateConcept = api('POST /api/gallery-concepts/activate');
export const moveToPreviewConcept = api(
  'POST /api/gallery-concepts/move-to-preview'
);
export const unarchiveConcept = api('POST /api/gallery-concepts/unarchive');
export const inactiveConcept = api('POST /api/gallery-concepts/inactive');

export const createConcept = api('POST /api/gallery-concepts');
export const updateConcept = api('PUT /api/gallery-concepts/:id');
export const removeConcepts = api('POST /api/gallery-concepts/delete');

export const exportConcepts = api('POST /api/gallery-concepts/export');
export const checkExportConcepts = api('GET /api/gallery-concepts/export');

export const batchShareConcepts = api('POST /api/gallery-concepts/share');
export const batchUnshareConcepts = api('POST /api/gallery-concepts/unshare');

export const markAsReadConcepts = api('POST /api/gallery-concepts/is-new/read');
export const loadConceptDownloadUrl = api(
  'GET /api/gallery-concepts/:id/download-url'
);
export const loadConceptCopyUrl = api('GET /api/gallery-concepts/:id/view-url');
export const loadConceptActionsLog = api(
  'GET /api/gallery-concepts/:id/actions-log'
);
export const loadAttachments = api('GET /api/gallery-concepts/:id/attachments');
export const uploadAttachments = api(
  'POST /api/gallery-concepts/upload-attachments'
);

export const loadTranscriptions = api(
  'GET /api/gallery-concepts/transcriptions/:id'
);
export const bulkEditConcepts = api('PUT /api/gallery-concepts/edit');
